import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {handleURL} from '../../../../../../utilities/StringHelpers/StringHelpers';
import gaParams from '../../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../../utilities/analytics/tracking';
import Helper from '../../../../../../utilities/analytics/helper';
import {
  setActiveLobbyTab,
  setStartedFromTracker,
  setCurrentSubscriber,
} from '../../../../../Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {connect} from 'react-redux';
import './tracker.scss';
import {setSelectedSubscriber} from './../../../SelfCareSlice';
import {
  RefundItemExpanded,
  PlanChangeItemExpanded,
  FollowUpRefundItemExpanded,
  AbroadPackageItemExpanded,
  CustomerDeliveriesItemExpanded,
  FinanceIssueItemExpanded,
  AbroadInsuranceItemExpanded,
  TechnicianVisitItemExpanded,
  CouponReceivedItemExpanded,
} from './trackerItemExpanded';
import {popUpEnum} from './trackerEnum';
import {dwhViewUpdates} from '../dwhReports';
import {TAB_ENUM} from 'app/Components/Page/SelfCarePage/Constant';

const TrackerExpanded = (props) => {
  console.log(props);
  function reportDwh() {
    const userDetails = props.userData.userDetails;
    const fullName = userDetails.firstName + ' ' + userDetails.lastName;
    const idNumber = userDetails.IDNumber;
    const subscriber = userDetails.contactNumber;
    const ban = userDetails.Ban;
    const isContactPerson = userDetails.IsContactPerson;
    const loginType = props.userData.isOtpExtendedAuthenticated ? 'מורחב/לקוח' : 'OTP/OTP';
    dwhViewUpdates(
      fullName,
      subscriber,
      idNumber,
      ban,
      null,
      null,
      null,
      props.selfCareSliceTracker.orderedTrackerItems.length,
      isContactPerson,
      loginType,
    );
  }

  useEffect(() => {
    reportDwh();
  }, []);

  const [currOpenItem, setCurrOpenItem] = useState('');
  const ics = require('ics');
  const {saveAs} = require('file-saver');

  const handleItemState = (itemType) => {
    if (currOpenItem === itemType) {
      setCurrOpenItem('');
      return;
    }
    setCurrOpenItem(itemType);
  };

  useEffect(() => {
    if (isMobile) {
      handleItemState(props?.selfCareSliceTracker?.popUpProps?.id);
    } else {
      if (props?.selfCareSliceTracker?.popUpType !== popUpEnum.FINANCE_ISSUE) {
        handleItemState(`${props?.selfCareSliceTracker?.popUpType}0`);
      }
    }
  }, []);

  const navigateToPage = (url) => {
    handleURL(url, props.context);
  };

  const openUrl = (el) => {
    if (typeof el.url === 'object' && el.url !== null) {
      gaEvent(
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.category,
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventType,
        Helper.objToString(
          {popUpType: props.selfCareSliceTracker.popUpType, action: 'addToCalendar'},
          gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventParams,
        ),
      );
      ics.createEvent(el.url, (error, value) => {
        if (error) {
          return;
        }
        var file = new File([value], 'event.ics', {type: 'text/calendar'});
        saveAs(file);
      });
    } else {
      gaEvent(
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.category,
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventType,
        Helper.objToString(
          {popUpType: props.selfCareSliceTracker.popUpType, action: 'editAction'},
          gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventParams,
        ),
      );
      if (props.clearCache) props.clearCache(props.selfCareSliceTracker.popUpType);
      props.handleIdPopup(el.url);
    }
  };

  const handleCloseTracker = () => {
    props.closePage();
  };

  const abroadInsuranceUrl = props?.URLS?.abroadInsuranceUrl?.value;

  return (
    <div>
      <div className='tracker-expanded-container'>
        <div className='tracker-expanded-header'>
          {isMobile && <div className='back-arrow' onClick={() => props.closePage()}></div>}
          <span className='tracker-expanded-title'>{`עדכונים (${props.selfCareSliceTracker.numOfItems})`}</span>
        </div>
        <div className='expanded-items-container'>
          {props.selfCareSliceTracker.orderedTrackerItems.map((element, index) => {
            switch (element._type) {
              case 'FinanceIssue':
                return (
                  <FinanceIssueItemExpanded
                    {...element}
                    URLs={props.contentData}
                    context={props.context}
                    handleActionClick={(url) => props.handleIdPopup(url)}
                    openUrl={openUrl}
                    id={`FinanceIssue${index}`}
                  />
                );
              case 'Refund':
                return (
                  <RefundItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    openUrl={openUrl}
                    id={`Refund${index}`}
                    key={`Refund${index}`}
                  />
                );
              case 'FollowUpRefund':
                return (
                  <FollowUpRefundItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    openUrl={openUrl}
                    id={`FollowUpRefund${index}`}
                    key={`FollowUpRefund${index}`}
                  />
                );
              case 'AbroadPackage':
                return (
                  <AbroadPackageItemExpanded
                    {...element}
                    context={props.context}
                    URLs={props.contentData}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    openUrl={openUrl}
                    id={`AbroadPackage${index}`}
                    key={`AbroadPackage${index}`}
                    setStartedFromTracker={props.setStartedFromTracker}
                    setActiveLobbyTab={props.setActiveLobbyTab}
                    urlToAbroad={props?.contentData?.pageRefToMyAbroadPackage?.value?.url}
                    handleCloseTracker={handleCloseTracker}
                  />
                );
              case 'PlanChange':
                return (
                  <PlanChangeItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    openUrl={openUrl}
                    cellularWorldLink={props?.contentData?.cellularWorldLink?.value}
                    id={`PlanChange${index}`}
                    key={`PlanChange${index}`}
                    context={props.context}
                    handleCloseTracker={handleCloseTracker}
                    setSelectedSubscriber={props.setSelectedSubscriber}
                    cellularSubscribers={props.selfCareSlice.subscribersByProduct[TAB_ENUM.Cellular]}
                  />
                );
              case 'CustomerDeliveries':
                return (
                  <CustomerDeliveriesItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    openUrl={openUrl}
                    id={`CustomerDeliveries${index}`}
                    key={`CustomerDeliveries${index}`}
                    URLs={props.contentData}
                  />
                );
              case 'AbroadInsurance':
                return (
                  <AbroadInsuranceItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    abroadInsuranceUrl={abroadInsuranceUrl}
                    context={props.context}
                    subscriber={element.subscriber}
                    ban={element.banId}
                    name={props.userData?.userDetails?.firstName + ' ' + props.userData?.userDetails?.lastName}
                    id={props.userData?.userDetails?.IDNumber || `AbroadInsurance${index}`}
                    setCurrentSubscriber={props.setCurrentSubscriber}
                    openUrl={openUrl}
                    key={`AbroadInsurance${index}`}
                  />
                );
              case 'TechnicianVisit':
                return (
                  <TechnicianVisitItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    URLs={props.contentData}
                    navigateToPage={navigateToPage}
                    clearCache={props.clearCache}
                    openUrl={openUrl}
                    id={`TechnicianVisit${index}`}
                    key={`TechnicianVisit${index}`}
                  />
                );
              case 'CouponReceived':
                console.log(element);
                return (
                  <CouponReceivedItemExpanded
                    {...element}
                    handleItemState={handleItemState}
                    currOpenItem={currOpenItem}
                    openUrl={openUrl}
                    id={`CouponReceived${index}`}
                    key={`CouponReceived${index}`}
                    couponHistoryUrl={props?.contentData?.couponHistoryPageLink?.value}
                    handleCloseTracker={handleCloseTracker}
                  />
                );
            }
          })}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    selfCareSliceTracker: state.selfcarePage.selfCareData.trackers,
    userData: state.authentication?.loginData,
    authentication: state.authentication,
    selfCareSlice: state.selfcarePage,
  };
};

const mapDispatchToProps = {
  setActiveLobbyTab,
  setStartedFromTracker,
  setCurrentSubscriber,
  setSelectedSubscriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackerExpanded);
